import {
  type ApiResponse,
  type PaginatedResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

import type {
  CreditNote,
  CreateCreditNoteInput
} from './types/credit-notes.types';

export interface ListCreditNotesParams {
  invoiceId?: number
  limit?: number
  offset?: number
}

export async function listCreditNotes(
  params: ListCreditNotesParams = {},
  token: string
): Promise<PaginatedResponse<CreditNote>> {

  const query = new URLSearchParams();

  if (params.invoiceId !== undefined) {

    query.set('invoiceId', String(params.invoiceId));
  }

  if (params.limit !== undefined) {

    query.set('limit', String(params.limit));
  }

  if (params.offset !== undefined) {

    query.set('offset', String(params.offset));
  }

  const qs = query.size > 0 ? `?${ query.toString() }` : '';
  return apiRequest<PaginatedResponse<CreditNote>>(`/credit-notes${ qs }`, undefined, token);
}

export async function getCreditNoteById(
  id: number,
  token: string
): Promise<ApiResponse<CreditNote>> {

  return apiRequest<ApiResponse<CreditNote>>(`/credit-notes/${ id }`, undefined, token);
}

export async function createCreditNote(
  invoiceId: number,
  input: CreateCreditNoteInput,
  token: string
): Promise<ApiResponse<CreditNote>> {

  return apiRequest<ApiResponse<CreditNote>>(
    `/invoices/${ invoiceId }/credit-notes`,
    {
      method: 'POST',
      body: JSON.stringify(input)
    },
    token
  );
}

export async function issueCreditNote(
  id: number,
  token: string
): Promise<ApiResponse<CreditNote>> {

  return apiRequest<ApiResponse<CreditNote>>(
    `/credit-notes/${ id }/issue`,
    {
      method: 'POST'
    },
    token
  );
}

export async function applyCreditNote(
  id: number,
  token: string
): Promise<ApiResponse<CreditNote>> {

  return apiRequest<ApiResponse<CreditNote>>(
    `/credit-notes/${ id }/apply`,
    {
      method: 'POST'
    },
    token
  );
}

export async function voidCreditNote(
  id: number,
  token: string
): Promise<ApiResponse<CreditNote>> {

  return apiRequest<ApiResponse<CreditNote>>(
    `/credit-notes/${ id }/void`,
    {
      method: 'POST'
    },
    token
  );
}
